$(document).on('change', '.account #timezone', function() {
  $.post('/account', { timezone: $(this).val(), '_method': 'PUT' })
})
